/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CancelSampleRequestMutationRequest,
  CancelSampleRequestMutationResponse,
  CancelSampleRequestPathParams,
  CancelSampleRequest400,
  CancelSampleRequest404,
} from '../types/CancelSampleRequest'

function getCancelSampleRequestUrl({
  id,
}: {
  id: CancelSampleRequestPathParams['id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/samples/sample-requests/${id}/cancel/` as const,
  }
  return res
}

/**
 * @description Cancel a sample request.
 * Returns:
 * 200: Sample request cancelled successfully
 * 400: Validation error or business logic error (e.g., already cancelled, missing reason)
 * 404: Sample request not found
 * 500: Unexpected server error
 * @summary Cancel a sample request
 * {@link /api/v1/samples/sample-requests/:id/cancel/}
 */
export async function cancelSampleRequest(
  { id }: { id: CancelSampleRequestPathParams['id'] },
  data?: CancelSampleRequestMutationRequest,
  config: Partial<RequestConfig<CancelSampleRequestMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CancelSampleRequestMutationResponse,
    ResponseErrorConfig<CancelSampleRequest400 | CancelSampleRequest404>,
    CancelSampleRequestMutationRequest
  >({
    method: 'POST',
    url: getCancelSampleRequestUrl({ id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
